const DOCUMENT_RULE_CONFIGURATIONS = {
    REQUIRED:{
        REQUIRED: 'Document is required',
        NO_REQUIRED: 'Document is not required'
    },
    EXPIRATION:{
        DEFAULT_VALUE: '-1',
        NO_EXPIRE_TEXT: 'Does not expire'
    },
    NOTIFICATION:{
        DEFAULT_VALUE:'-1'
    }
};

const DOCUMENT_RULE_TYPES = {
    DOCUMENT:"DOCUMENT",
    REPORT: "REPORT",
    AUTHORIZATION:"AUTHORIZATION"
};

const DOCUMENT_RULE_STATUS = {
    INACTIVE: "INACTIVE",
    ACTIVE: "ACTIVE"
};

const DOCUMENT_RULE_ACTIONS = {
    CLONE: {
        text: 'clone',
        icon: 'mdi-content-copy'
    },
    DELETE:{
        text: 'delete',
        icon: 'mdi-delete'
    }
};

export {
    DOCUMENT_RULE_CONFIGURATIONS,
    DOCUMENT_RULE_TYPES,
    DOCUMENT_RULE_STATUS,
    DOCUMENT_RULE_ACTIONS
}